import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { MosaicCardBlockConfig } from '@front-platform/content-builder';
import { mosaicCardBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

import { ShopSearchParametersService } from '@core/services/shop-search-parameters/shop-search-parameters.service';
export interface MosaicCardBlockRuntimeConfig {
  '"aspect-ratio"'?: string | undefined;
}

export type MosaicCardBlockConfigInput = Partial<
  Omit<MosaicCardBlockConfig, keyof MosaicCardBlockRuntimeConfig> & MosaicCardBlockRuntimeConfig
>;
export type MosaicCardBlockResolvedConfig = Omit<
  MosaicCardBlockConfig,
  keyof MosaicCardBlockRuntimeConfig
> &
  Partial<MosaicCardBlockRuntimeConfig>;
export interface MosaicCardBlockContract extends ConfigComponentContract<
  MosaicCardBlockConfigInput,
  MosaicCardBlockResolvedConfig
> {}

@Component({
  selector: 'app-mosaic-card-block',
  templateUrl: './mosaic-card-block.component.html',
  styleUrls: ['./mosaic-card-block.component.scss'],
  standalone: false,
})
export class MosaicCardBlockComponent implements MosaicCardBlockContract {
  readonly config = input<MosaicCardBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    MosaicCardBlockConfig,
    MosaicCardBlockRuntimeConfig
  >(mosaicCardBlockResolveConfig, () => ({ config: this.config() }));
  get width(): string | undefined {
    return this.resolvedConfig()['width'] as unknown as string | undefined;
  }
  get backgroundImage(): any | undefined {
    return this.resolvedConfig()['background_image'] as unknown as any | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  get linkTarget(): string {
    return this.resolvedConfig()['link_target'] as unknown as string;
  }
  get distributionMode(): string | undefined {
    return this.resolvedConfig()['distribution_mode'] as unknown as string | undefined;
  }
  get heading(): string | undefined {
    return this.resolvedConfig()['heading'] as unknown as string | undefined;
  }
  get aspectRatio(): string | undefined {
    return this.resolvedConfig()['"aspect-ratio"'] as unknown as string | undefined;
  }
  get shadow(): string | undefined {
    return this.resolvedConfig()['shadow'] as unknown as string | undefined;
  }
  get rounded(): string | undefined {
    return this.resolvedConfig()['rounded'] as unknown as string | undefined;
  }
  get font(): string | undefined {
    return this.resolvedConfig()['font'] as unknown as string | undefined;
  }
  get fontSize(): string | undefined {
    return this.resolvedConfig()['font_size'] as unknown as string | undefined;
  }
  get backgroundStyleContain(): boolean | undefined {
    return this.resolvedConfig()['background_style_contain'] as unknown as boolean | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get backgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor;
  }

  constructor(private readonly shopSearchParametersService: ShopSearchParametersService) {}

  onClick(): void {
    if (this.distributionMode) {
      // Preset the mode so CartParametersModalLauncherBlock opens the cart parameters modal
      // on shop page. Clears force_distribution_mode from QR/URL so the chosen mode can apply.
      this.shopSearchParametersService.applyUserSelectedDistributionMode(this.distributionMode);
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(MosaicCardBlockComponent, {
  keyAliases: { aspect_ratio: '"aspect-ratio"' },
});
